export default __webpack_public_path__ + "assets/fonts/toolbar-icon.83a6d171cd16efcdc96151381e156652.eot";